module.exports = __webpack_public_path__ + "media/images/sp/top/area_brand_tvb@3x-e4542017004da0815b62d194590ecfd3.webp";